import { Link } from "gatsby"
import * as React from "react"

export const CustomButton = ({ text, type, disabled }) => {
    return (
        <>
            <button type={type ?? 'button'} disabled={disabled ?? false}>
                {text}
            </button>
        </>
    )
}

export const CustomLinkBtn = ({ text, url, icon, otherProps }) => {
    return (
        <>
            <Link to={url} {...otherProps} target={url && "_blank"}>
                {text} {icon ?? ''}
            </Link>
        </>
    )
}


